module.exports = __webpack_public_path__ + "img/33-image-2@2x.57e28c4a.png";